import {
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalHeader,
  ModalOverlay,
  ModalProps,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import { ReactNode } from 'react'

export interface BaseModalProps extends ModalProps {
  title: ReactNode
  width?: ModalContentProps['width']
  height?: ModalContentProps['height']
}
export function BaseModal({ title, width, height, ...rest }: BaseModalProps) {
  const isMobile = useBreakpointValue({ base: true, md: false })
  const header = (
    <>
      <Text fontSize="20px">{title}</Text>
      <ModalCloseButton />
    </>
  )
  if (isMobile) {
    return (
      <Drawer {...rest} placement="bottom">
        <DrawerOverlay />
        <DrawerContent rounded={20}>
          <DrawerContent maxH="calc(100vh - 40px)" p={0} display="flex" flexDir="column">
            <DrawerHeader display="flex" flexDir="row" padding="16px 16px 0 16px">
              {header}
            </DrawerHeader>
            <DrawerBody p={6} display="flex" flexDir="column">
              {rest.children}
            </DrawerBody>
          </DrawerContent>
        </DrawerContent>
      </Drawer>
    )
  }
  return (
    <Modal isCentered {...rest} onEsc={rest.onClose}>
      <ModalOverlay />
      <ModalContent rounded={20} width={width} height={height} maxW="auto" maxH="auto">
        <ModalHeader display="flex" flexDir="row" padding="24px 24px 0 24px">
          {header}
        </ModalHeader>
        <ModalBody p={6} display="flex" flexDir="column">
          {rest.children}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
